<template>
  <app-page>
    <div class="purchase">
      <div class="cover">
        <img src="@/assets/images/about/purchase_cover.png" alt="">
      </div>
      <div class="content">
        <about-title title="购买方式"></about-title>
        <div class="modes">
          <div class="mode">
            <span class="icon">01</span>
            <div class="content">
              <h3 class="title">微信购买<span class="subtitle">WeChat purchase</span></h3>
              <div class="box">
                <p>选择满意宝贝后，点击联系微信客服，添加我们的微信客服账号，取得联系后购买。 </p>
              </div>
            </div>
          </div>
          <div class="mode">
            <span class="icon">02</span>
            <div class="content">
              <h3 class="title">在线咨询购买<span class="subtitle">Online consultation and purchase</span></h3>
              <div class="box">
                <p>选择满意宝贝后，点击联系客服，选择在线咨询购买。</p>
              </div>
            </div>
          </div>
          <div class="mode">
            <span class="icon">03</span>
            <div class="content">
              <h3 class="title">电话订购<span class="subtitle">Telephone order</span></h3>
              <div class="box">
                <p>您在翡翠王朝上看到心仪的宝贝后，可电话联系下单。</p>
                <p>公司热线：0692-6990865/0692-6991717 0692-6991818</p>
                <p>全国免费电话：400-6291314</p>
              </div>
            </div>
          </div>
        </div>
        <about-title number="02" title="物流保障"></about-title>
        <div class="questions">
          <div class="question">
            <span class="icon">Q1</span>
            <div class="content">
              <h3 class="title">你们快递是哪家?</h3>
              <div class="box">
                <p>选择满意宝贝后，点击联系客服，选择在线咨询购买。</p>
              </div>
            </div>
          </div>
          <div class="question">
            <span class="icon">Q2</span>
            <div class="content">
              <h3 class="title">包装安全吗?</h3>
              <div class="box">
                <p>亲，翡翠王朝均采用定制高强度防震/防压包装。同时，翡翠王朝为您购买的宝贝提供免费全程保价服务。由中国平安保险公司提供全程运输保险。</p>
              </div>
            </div>
          </div>
          <div class="question">
            <span class="icon">Q3</span>
            <div class="content">
              <h3 class="title">退货要按原包装退回吗?</h3>
              <div class="box">
                <p>是的，请按原包装将翡翠、鉴定证书﹑收据﹑首饰盒一并寄回。</p>
              </div>
            </div>
          </div>
          <div class="question">
            <span class="icon">Q4</span>
            <div class="content">
              <h3 class="title">我想退货（换货）</h3>
              <div class="box">
                <p>请联系翡翠王朝在线客服或微信客服。</p>
              </div>
            </div>
          </div>
          <div class="question">
            <span class="icon">Q5</span>
            <div class="content">
              <h3 class="title">退货后什么时候退款呢?</h3>
              <div class="box">
                <p>翡翠王朝将在收到宝贝确认无误后两个工作日内为您办理退款（遇国家法定节假日则相应顺延）</p>
              </div>
            </div>
          </div>
          <div class="question">
            <span class="icon">Q6</span>
            <div class="content">
              <h3 class="title">退货时有什么对包装要求吗?</h3>
              <div class="box">
                <p>需按"翡翠王朝"邮寄时的包装方法寄回，使用中国邮政、顺丰邮寄并保价。</p>
              </div>
            </div>
          </div>
          <div class="question">
            <span class="icon">Q7</span>
            <div class="content">
              <h3 class="title">不能退换货的情况</h3>
              <div class="box">
                <p>1. 超过退换货期限7天的;</p>
                <p>2. 未经授权对产品进行处理、误用、打磨、镶嵌、事故、改动的;</p>
                <p>3. 订制类产品，如私人定制、改指圈、代镶嵌、代加工和事先约定好不接受退换货的;</p>
                <p>4. 没有与翡翠王朝客服事先联系而直接将货物寄回;</p>
                <p>5. 未使用中国邮政、顺丰或指定快递邮寄并保价的;</p>
                <p>6. 产品不完整、鉴定证书、收据、首饰盒等随附属物不齐全的。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <about-footer></about-footer>
    </div>
  </app-page>
</template>

<script>
  import AppPage from '../layouts/Main';
  import AboutFooter from './components/AboutFooter';
  import AboutTitle from './components/AboutTitle';
    export default {
        name: 'contact',
        components: {
          AppPage,AboutTitle,AboutFooter
        },
        data() {
            return {

            }
        },
        computed: {
        },
        mounted() {
        },
        methods:{

        }
    }
</script>

<style lang="scss" scoped >
  .purchase{
    background-color: rgba(255,255,255,1);
  }
  .content{
    padding: 0 0.21rem;
    text-align: left;
    .modes{
      .mode{
        display: flex;
        padding-bottom: 0.46rem;
        .icon{
          font-size:0.48rem;
          font-weight:bold;
          color:rgba(139,139,139,1);
          line-height:0.48rem;
          margin-right: 0.12rem;
        }
        .content{
          .title{
            font-size:0.2133rem;
            font-weight:500;
            color:rgba(29,29,29,1);
            line-height:0.2133rem;
            display: flex;
            padding-bottom: 0.2rem;
            .subtitle{
              font-size:0.12rem;
              font-weight:400;
              color:rgba(29,29,29,1);
              line-height:0.12rem;
              margin-left: 0.05rem;
            }
          }
          .box{
            background:rgba(255,255,255,1);
            border-radius:0.04rem;
            border:0.0067rem solid rgba(225,225,225,1);
            padding: 0.21rem 0.16rem;
            p{
              font-size:0.1867rem;
              color:rgba(29,29,29,1);
              line-height:0.2667rem;
            };
          }
        }
      }
      .mode:last-child{
        padding-bottom: 0;
      }
    }
    .questions{
      .question{
        display: flex;
        padding-bottom: 0.4rem;
        .icon{
          width: 0.45rem;
          height: 0.47rem;
          background-image: url("../../assets/svg/about/purchase_question.svg");
          background-size: cover;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-shrink: 0;
          font-size:0.1867rem;
          font-weight:400;
          color:rgba(255,255,255,1);
          line-height:0.1333rem;
          padding-bottom: 0.07rem;
        }
        .content{
          .title{
            font-size:0.2133rem;
            font-weight:500;
            color:rgba(29,29,29,1);
            line-height:0.2133rem;
            display: flex;
            padding-bottom: 0.2rem;
            .subtitle{
              font-size:0.12rem;
              font-weight:400;
              color:rgba(29,29,29,1);
              line-height:0.12rem;
              margin-left: 0.05rem;
            }
          }
          .box{
            background:rgba(255,255,255,1);
            border-radius:0.04rem;
            border:0.0067rem solid rgba(225,225,225,1);
            padding: 0.21rem 0.16rem;
            p{
              font-size:0.1867rem;
              color:rgba(29,29,29,1);
              line-height:0.2667rem;
              padding-bottom: 0.15rem;
            };
            p:last-child{
              padding-bottom: 0;
            }
          }
        }
      }
    }
  }


</style>
